import React, { useEffect, useState, useRef } from "react";
import Cookies from "js-cookie";
import { Typeahead } from "react-bootstrap-typeahead";
import { FetchSecurityMaster, postNewTrades, postTrades } from "../../api/api";
import "react-bootstrap-typeahead/css/Typeahead.css";
import clsx from "clsx";
import axios, { Axios } from "axios";
import moment from "moment";

function TradeForm() {
  const [securityMaster, setSecurityMaster] = useState<any>(null);
  const [selected, setSelected] = useState<any>([]);
  const [orderType, setOrderType] = useState<any>();
  const [timeForce, setTimeForce] = useState<any>([]);
  const [symbolValue, setSymbolValue] = useState<any>(null);
  const [costType, setCostType] = useState<any>([]);
  const [enableQuantity, setEnableQuantity] = useState(false);
  const [showSymbol, setShowSymbol] = useState();
  const [showResponse, setShowResponse] = useState(false);
  const [responseStatus, setResponseStatus] = useState<any>();
  const [FormData, setFormData] = useState<any>({
    trade: "Buy",
    quantity: "",
    orderType: "",
    limitPrice: "",
    timeInForce: "",
    cancelTime: ""
  });
  const [cancelDays, setCancelDays] = useState<any>(null)
  const ref = useRef(null);

  const typeHeadOptions: any[] = [];
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchSecurityMaster("SecurityMaster", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSecurityMaster(response);
      });
  }, []);

  useEffect(() => {
    FetchSecurityMaster("OrderType", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setOrderType(response);
      });
  }, []);

  // useEffect(() => {
  //   FetchSecurityMaster("TimeInForce", Cookies.get("newJwt"))
  //     .then((response) => response.json())
  //     .then((response) => {
  //       setTimeForce(response);
  //     });
  // }, []);

  useEffect(() => {
    FetchSecurityMaster("CostType",parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setCostType(response);
      });
  }, []);

  securityMaster &&
    securityMaster.map((e: any) => {
      return typeHeadOptions.push({
        label: e.security,
        description: e.description,
        allowTrading: e.allowTrading,
        countryName: e.countryName,
        availableQty: e.availableQty,
        industryName: e.industryName,
        gainLoss: e.gainLoss,
        perf: e.perf,
      });
    });

  const {
    trade,
    quantity,
    getOrderType,
    limitPrice,
    timeInForce,
    cancelTime
  } = FormData;

  const changeHandler = (e: any) => {
    setFormData({
      ...FormData,
      [e.target.name]: [e.target.value],
      symbol: [
        selected &&
          selected.map((e: any) => {
            return e.label;
          }),
      ],
    });
  };

  useEffect(() => {
    selected &&
      selected.map((e: any) => {
        return setShowSymbol(e.label);
      });
  }, [selected]);

  useEffect(() => {
    setSymbolValue(JSON.stringify(selected[0] && selected[0].label));
    selected &&
      selected.map((e: any) => {
        const value = selected[0].availableQty >= 0 ? true : false;
        setEnableQuantity(selected[0].availableQty <= 0 ? true : false);
        return value
      });

    if (trade && trade[0] === "Sell") {
      setFormData({
        ...FormData,
        trade: "SELL",
        symbol: "",
        quantity: "",
        getOrderType: "",
        limitPrice: "",
        timeInForce: "",
        cancelTime: ""
       
      });
    }
  }, [FormData, orderType, quantity, selected, trade]);
  var myDate = new Date(cancelTime);


useEffect(() => {
  var getDate = new Date(cancelTime);
  var SelectedDate = moment(getDate);
  const bufferDate =  moment([]).add(180, 'days')
  var finalDate = moment(bufferDate);
  setCancelDays(SelectedDate.diff(finalDate, 'days'))
  
}, [cancelDays, cancelTime])


  


  const handleSubmit = (e: any) => {
    e.preventDefault();

    postNewTrades(
      {
        orderType: FormData?.getOrderType?.toString().toUpperCase(),
        session: "NORMAL",
        duration: timeInForce.toString(),
        Price: FormData?.getOrderType?.toString().toUpperCase() !== 'MARKET' ?   parseInt(limitPrice) : null,
        orderStrategyType: "SINGLE",
        
        cancelTime: myDate ? moment(myDate).format("YYYY-MM-DD").toString() : null,
        orderLegCollection: [
          {
            instruction: FormData?.trade?.toString().toUpperCase(),
            quantity: FormData?.quantity?.toString().length ? parseInt(FormData?.quantity) : null,
            instrument: {
              symbol: showSymbol,
              assetType: "EQUITY",
            },
          },
        ],
      },
      Cookies.get("newJwt")
    )
      .then((response) => response)
      .then((response) => {
        if (response) {
          setShowResponse(true);
          setResponseStatus(response.status);
          
        }
        
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if(showResponse === true){
      setTimeout(() => {
        setShowResponse(false);
      }, 10000);
    }
    
  }, [showResponse]);
  
  const clearAll = () =>{
    
    
  }
  

  return (
    <div className="w-100 tradeForm position-relative">
      {showResponse && showResponse ? (
        <div
          className={clsx(
            "alert alert-dismissible position-absolute statusAlert",

            responseStatus === 200 ? "alert-success" : "alert-warning"
          )}
          role="alert"
        >
          <div className="alert-message">
            {responseStatus === 200 ? (
              <>
                <strong>Trade</strong> created successfully!{" "}
              </>
            ) : (
              <>
                Error Creating <strong>Trade</strong>
              </>
            )}
          </div>

          <button
            type="button"
            className="btn-close btn-close-white"
            data-bs-dismiss="alert"
            aria-label="Close"
            onClick={() => setShowResponse(false)}
          ></button>
        </div>
      ) : null}

      <form onSubmit={handleSubmit} id="formRef" >
        <div className="row w-100 card p-4">
          <div className="col-sm-5 d-inline-flex py-4">
            <span className="col-sm-3">Trade</span>
            <div className="form-check">
              <input
                type="radio"
                className="form-check-input"
                id="radio1"
                name="trade"
                value="BUY"
                onChange={changeHandler}
                defaultChecked
              />
              <label className="form-check-label" htmlFor="radio1">
                Buy
              </label>
            </div>
            <div className="form-check mx-4">
              <input
                type="radio"
                className="form-check-input"
                id="radio2"
                name="trade"
                value="SELL"
                onChange={changeHandler}
              />
              <label className="form-check-label" htmlFor="radio2">
                Sell
              </label>
            </div>
          </div>
          <div className="col-sm-12 position-relative">
            <div className="col-sm-7 d-inline-flex ">
              <div className="mb-3 d-flex col-sm-6 pe-2">
                <label className="col-sm-4 col-form-label">Symbol</label>
                <div className="col-sm-8 col-form-label">
                  <Typeahead
                    id="basic-example"
                    onChange={setSelected}
                    options={typeHeadOptions}
                    placeholder="Choose a Symbol..."
                    selected={selected}
                    ref={ref}
                  />
                </div>
              </div>
              <div className="mb-3 d-flex col-sm-6 mx-2">
                <label className="col-sm-5 col-form-label px-4">Quantity</label>
                <div className="col-sm-7 col-form-label ">
                  <input
                    className="form-control"
                    type="number"
                    placeholder={
                      selected &&
                      selected.map((e: any) => {
                        return trade && trade[0] !== "Sell"
                          ? selected[0].availableQty
                          : null;
                      })
                    }
                    disabled={
                      trade && trade[0] === "SELL" && enableQuantity ?  true : false
                    }
                    name="quantity"
                    value={quantity}
                    onChange={changeHandler}
                  ></input>
                </div>
              </div>
            </div>
            <div className="col-sm-7 d-inline-flex ">
              <div className="mb-3 d-flex col-sm-6 pe-2">
                <label className="col-sm-4 col-form-label">Order Type</label>
                <div className="col-sm-8 col-form-label">
                  <select
                    className="form-control"
                    name="getOrderType"
                    value={getOrderType}
                    onChange={changeHandler}
                  >
                    <option defaultValue="Select Order Type">
                      Select Order Type
                    </option>
                    {orderType &&
                      orderType.map((e: any) => {
                        return (
                          <option value={e.orderType} key={e.orderTypeID}>
                            {e.orderType}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>
              <div className="mb-3 d-flex col-sm-6 mx-2">
                <label className="col-sm-5 col-form-label px-4">
                  Limit Price
                </label>
                <div className="col-sm-7 col-form-label ">
                  <input
                    type="text"
                    className="form-control"
                    disabled={
                      JSON.stringify(getOrderType) === '["Market"]' ||
                      JSON.stringify(getOrderType) === '["Stop Market"]' ||
                      JSON.stringify(getOrderType) === '["Stop Limit"]'
                        ? true
                        : false
                    }
                    name="limitPrice"
                    value={limitPrice}
                    onChange={changeHandler}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-7 d-inline-flex ">
              <div className="mb-3 d-flex col-sm-6 pe-2">
                <label className="col-sm-4 col-form-label">Duration</label>
                <div className="col-sm-8 col-form-label">
                  <select
                    className="form-control"
                    name="timeInForce"
                    value={timeInForce}
                    onChange={changeHandler}
                  >
                    <option>Select</option>
                    <option value="DAY">DAY</option>
                    <option value="GOOD_TILL_CANCEL">GOOD_TILL_CANCEL</option>
                    {/* <option value="FILL_OR_KILL">FILL_OR_KILL</option> */}
                  </select>
                </div>

                {/* <div className="col-sm-4 col-form-label px-2 d-flex">
                  {timeInForce.toString() === "Day" ||
                  timeInForce.toString() === "Day Ext" ? (
                    <>
                      <input
                        type="text"
                        className="form-control mx-2"
                        style={{ width: "50px" }}
                        name="timeInForceOne"
                        value={timeInForceOne}
                        onChange={changeHandler}
                      />
                      <input
                        type="text"
                        className="form-control "
                        style={{ width: "50px" }}
                        name="timeInForceTwo"
                        value={timeInForceTwo}
                        onChange={changeHandler}
                      />
                    </>
                  ) : (
                    ""
                  )}
                </div> */}
              </div>
              {timeInForce.toString() === "GOOD_TILL_CANCEL" ? (
                <div className="mb-3 d-flex col-sm-6 mx-2">
                  <label className="col-sm-5 col-form-label px-4">
                    Cancel Time
                  </label>
                  <div className="col-sm-7 col-form-label ">
                    <input
                      type="date"
                      className="form-control"
                      name="cancelTime"
                      value={cancelTime}
                      onChange={changeHandler}
                    />
                    {
                      cancelDays && cancelDays >= 0 ? <span className="text-danger">Cancel Time Should be less then 180 days</span> : null
                    }
                    
                  </div>
                </div>
              ) : null}

              {/* <div className="mb-3 d-flex col-sm-6 mx-2">
                <label className="col-sm-5 col-form-label px-4">Cost</label>
                <div className="col-sm-7 col-form-label ">
                  <select
                    className="form-control"
                    name="costTypeData"
                    value={costTypeData}
                    onChange={changeHandler}
                  >
                    <option>Select</option>
                    {costType &&
                      costType.map((e: any) => {
                        return (
                          <option value={e.costType} key={e.costTypeID}>
                            {e.costType}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div> */}
            </div>
            <div className="col-sm-4 d-inline-flex mx-4 position-absolute top-0 selectedData">
              {selected && selected.length ? (
                <div className="mx-4 w-100">
                  <div className="">Security : {selected[0].label}</div>
                  <div className="ellipsis">
                    Description : {selected[0].description}
                  </div>
                  <div>Allow Trading : {selected[0].allowTrading}</div>
                  <div className="">
                    Available Qty : {selected[0].availableQty}
                  </div>
                  <div className="">Industry : {selected[0].industryName}</div>
                  <div className="">
                    Country Name : {selected[0].countryName}
                  </div>
                  <div className="">GainLoss : {selected[0].gainLoss}</div>
                  <div className="">Perf : {selected[0].perf}</div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="row pt-4">
            <div className="float-end text-end d-flex justify-content-end">
              <button type="button" className="btn btn-link" onClick={clearAll}>
                Cancel
              </button>
          
              {
                trade && trade[0] === "SELL" ? 
                <button  
                type="submit" 
                className="btn btn-primary d-flex" 
                disabled={showResponse || cancelDays >= 0  || enableQuantity ? true : false}>
                Submit
                {showResponse && showResponse ? (
                  <div className="loader active">
                    <div className="splash-icon"></div>
                  </div>
                ) : null}
              </button>
              :
              <button  
              type="submit" 
              className="btn btn-primary d-flex" 
              disabled={showResponse || cancelDays >= 0  || Number(quantity) <= 0 ? true : false}>
              Submit
              {showResponse && showResponse ? (
                <div className="loader active">
                  <div className="splash-icon"></div>
                </div>
              ) : null}
            </button>
              }
           
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default TradeForm;
